// src/pages/Cleaning/Swaps/CleaningSwapListings.jsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { FaSyncAlt } from "react-icons/fa";
import { API_BASE_URL } from "../../../config";


function CleaningSwapListings() {
const formatCleaningTime = (time) => {
  if (!time) return "N/A";

  if (time === "30_minutes") return "0.5 hrs";
  if (time === "1_hour") return "1 hr";
  if (time === "1_5_hours") return "1.5 hrs";
  if (time === "2_hours") return "2 hrs";
  if (time === "3_hours") return "3 hrs";

  return `${time} hrs`;
};
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const [filters, setFilters] = useState({
    service: "Cleaning",
    mode: "swaps",
    state: "",
    postcode: "",
  });

  const [swaps, setSwaps] = useState([]);
  const [loading, setLoading] = useState(true);



const ROUTES = {
  Cleaning: {
    listings: "/cleaning/listings",
    swaps: "/cleaning/swaps",
    rounds: "/cleaning/rounds",
  },
  "Lawn Mowing": {
    listings: "/listings",
    swaps: "/swaps",
    rounds: "/lawn-mowing/rounds",
  },
  "Pool Care": {
    listings: "/poolcare/listings",
    swaps: "/poolcare/swaps",
  },
};


  useEffect(() => {
    async function load() {
      try {
        const token = localStorage.getItem("token");

        const res = await fetch(
          `${API_BASE_URL}/api/cleaning/swap-listings`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        setSwaps(
          Array.isArray(data)
            ? data
            : data.listings || data.swaps || []
        );
      } catch (err) {
        console.error("❌ Failed to load cleaning swaps:", err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [API_BASE_URL]);

  if (loading) return <p style={{ padding: 20 }}>Loading swaps…</p>;

  return (
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    minHeight: "100vh",
    overflow: "hidden",
    backgroundColor: "#f4f7f9",
  }}
>
   {/* ================= SIDEBAR ================= */}
<aside
 style={{
  width: isMobile ? "100%" : "250px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  padding: isMobile ? "4px 6px" : "20px",
  height: isMobile ? "auto" : "100vh",
  overflowY: isMobile ? "visible" : "auto",
  textAlign: "center",
}}
>
  <img
    src={logo}
    alt="Client Exchange"
    style={{ width: "140px", margin: "0 auto 25px" }}
  />



  {/* MODE */}
 <label style={{ fontWeight: "bold" }}>View:</label>
<select
  value={filters.mode}
onChange={(e) => {
  const nextMode = e.target.value;
  const service = filters.service || "Cleaning";

  const target = ROUTES?.[service]?.[nextMode];
  if (!target) return;

  setFilters((prev) => ({ ...prev, mode: nextMode }));
  navigate(target);
}}

 style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
>
<option value="listings">Listings</option>
<option value="swaps">Swaps</option>
<option value="rounds">Rounds</option>
</select>


  {/* SERVICE */}
  <label style={{ fontWeight: "bold" }}>Service:</label>
<select
  value={filters.service}
  onChange={(e) => {
    const service = e.target.value;
    const mode = filters.mode;

    setFilters({ ...filters, service });
    navigate(ROUTES[service][mode]);
  }}
style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
>
  <option value="Cleaning">Cleaning</option>
  <option value="Lawn Mowing">Lawn Mowing</option>
  <option value="Pool Care">Pool Care</option>
</select>


  {/* STATE */}
<label style={{ fontWeight: "bold" }}>Category:</label>
<select
  value={filters.category}
  onChange={(e) => {
    const category = e.target.value;
    setFilters({ ...filters, category });

    if (category === "Lawn Mowing") navigate("/listings");
    if (category === "Cleaning") navigate("/cleaning/listings");
    if (category === "Pool Care") navigate("/poolcare/listings");
  }}
  style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
>
  <option value="Lawn Mowing">Lawn Mowing</option>
  <option value="Cleaning">Cleaning</option>
  <option value="Pool Care">Pool Care</option>
</select>


  {/* POSTCODE */}
  <label style={{ fontWeight: "bold" }}>Postcode:</label>
  <input
    type="text"
    value={filters.postcode}
    onChange={(e) =>
      setFilters((prev) => ({ ...prev, postcode: e.target.value }))
    }
    placeholder="Enter Postcode"
   style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
  />

  {/* RESET */}
<button
  onClick={() => {
    setFilters({
      service: "Cleaning",
      mode: "swaps",
      state: "",
      postcode: "",
    });

    navigate("/cleaning/swaps");
  }}
  style={{
    ...buttonStyle,
    backgroundColor: "#d32f2f",
    marginTop: "10px",
  }}
>
  <FaSyncAlt /> Reset Filters
</button>
</aside>


      {/* MAIN */}
<main
  style={{
    flex: 1,
    minWidth: 0,
    padding: isMobile ? "12px" : "25px",
    overflowY: "auto",
    height: isMobile ? "auto" : "100vh",
  }}
>
        <h2 style={{ color: "#2e7d32" }}>
          Cleaning Swap Listings ({swaps.length})
        </h2>

        <div
  style={{
    textAlign: "center",
    background: "#eef8f0",
    border: "1px solid #cfe8d3",
    borderRadius: "12px",
    padding: "14px 18px",
    margin: "0 auto 20px",
    maxWidth: "700px",
    color: "#1b5e20",
    fontWeight: "700",
  }}
>
  🚀 Soft Launch: Be among the first contractors to list on Client Exchange.
</div>

        {swaps.length === 0 ? (
          <p>No cleaning swaps available.</p>
        ) : (
          <div style={grid}>
            {swaps.map((s) => (
  <div
    key={s.listingId}
    style={{ ...card, position: "relative" }}
  >

                <img
                  src="/images/cleaning.jpg"
                  alt="Cleaning Swap"
                  style={cardImage}
                />

                {/* 🔖 SWAP STATUS BADGE */}
{(() => {
  let text = "Available";
  let color = "#2e7d32";

  if (s.badge_requested) {
    text = "Swap Requested";
    color = "#1976d2";
  }

  if (s.badge_in_progress) {
    text = "Swap in Progress";
    color = "#f9a825";
  }

  if (s.badge_handover) {
    text = "Handover in Progress";
    color = "#6a1b9a";
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 10,
        left: 10,
        background: color,
        color: "#fff",
        padding: "4px 10px",
        borderRadius: 6,
        fontSize: 12,
        fontWeight: "bold",
        zIndex: 2,
      }}
    >
      {text}
    </div>
  );
})()}


              <div style={{ padding: "12px 15px" }}>
  <h2
    style={{
      margin: "0 0 4px 0",
      color: "#333",
      fontSize: "1.1rem",
      fontWeight: "600",
    }}
  >
    Swap – Cleaning
  </h2>

  <p
    style={{
      margin: "0 0 8px 0",
      color: "#777",
      fontSize: "0.8rem",
    }}
  >
    ID: <strong>{s.listingId}</strong>
  </p>

  <div
    style={{
      display: "grid",
     gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      rowGap: "6px",
      fontSize: "0.9rem",
    }}
  >
<div>
  <strong>From:</strong> {s.swap_from_suburb} {s.swap_from_postcode}
</div>

<div style={{ textAlign: "right" }}>
  <strong>To:</strong> {s.swap_to_suburb} {s.swap_to_postcode}
</div>

<div>
  🕒 {formatCleaningTime(s.cleaningTime)}
</div>

    <div style={{ textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 4 }}>
      <span>📅</span>
      <span style={{ fontWeight: "bold" }}>{s.frequency}</span>
    </div>

    <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
      Avg Job:{" "}
      {s.avg_job_price !== null && s.avg_job_price !== undefined
        ? `$${Number(s.avg_job_price).toFixed(2)}`
        : "Not specified"}
    </div>
  </div>

  <Link
    to={`/cleaning/swaps/${s.listingId}`}
    style={viewBtn}
  >
    View Details
  </Link>
</div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

/* styles */
const buttonStyle = {
  width: "100%",
  padding: 12,
  borderRadius: 8,
  border: "none",
  marginTop: 10,
  fontWeight: "bold",
  cursor: "pointer",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
  gap: 20,
};
const card = {
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  overflow: "hidden",
};

const cardImage = {
  width: "100%",
  height: 180,
  objectFit: "cover",
};

const viewBtn = {
  display: "block",
  width: "100%",
  marginTop: 8,
  textAlign: "center",
  padding: 10,
  background: "#2e7d32",
  color: "#fff",
  borderRadius: 6,
  textDecoration: "none",
};
/* ================= STYLES ================= */

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const options = {
  state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
};

export default CleaningSwapListings;
